import { colors } from '../config/chartColors'; // Импортируем общую палитру
// import { wrapText } from './textUtils'; // wrapText не используется, комментируем или удаляем импорт

/* // Функция для правильного склонения числительных (взята из ComplianceChart) - ПОКА НЕ ИСПОЛЬЗУЕТСЯ
const declOfNum = (number, titles) => {
  const cases = [2, 0, 1, 1, 1, 2];
  return titles[
    number % 100 > 4 && number % 100 < 20 
      ? 2 
      : cases[number % 10 < 5 ? number % 10 : 5]
  ];
}; 
*/

// Функция для форматирования даты 'YYYY-MM-DD' в 'ДД.ММ.ГГ' - не используется текущей логикой,
// но может быть полезна в будущем. Оставляем на всякий случай или удалить, если точно не нужна.
// const formatDatePart = (dateString) => { ... };

// TODO: Вынести палитру в общее место (например, src/config/chartColors.js или аналогичный файл,
// который затем будет копироваться в Firebase Functions) - СДЕЛАНО

const MSK_OFFSET_MILLISECONDS = 3 * 60 * 60 * 1000;

const DEFAULT_THRESHOLDS = { threshold1: 50, threshold2: 20 };
const EMPTY_UNIQUE_THRESHOLDS = { threshold1: 0.01, threshold2: 0.005 };

const determineThresholdsByValue = (items) => {
  if (items.length === 0) return DEFAULT_THRESHOLDS;

  const uniquePercentages = [...new Set(items.map(item => item.numericPercentage).filter(p => p > 0))].sort((a, b) => b - a);

  if (uniquePercentages.length === 0) return EMPTY_UNIQUE_THRESHOLDS; 
  if (uniquePercentages.length === 1) {
    // Если только одно уникальное значение > 0, оно определяет верхний порог (красный).
    // Нижний порог (для желтого/зеленого) делаем меньше.
    return { threshold1: uniquePercentages[0], threshold2: uniquePercentages[0] > 0 ? uniquePercentages[0] / 2 : -0.01 };
  }
  if (uniquePercentages.length === 2) {
    // Два уникальных значения: первое (большее) - порог для красного, второе (меньшее) - порог для желтого.
    return { threshold1: uniquePercentages[0], threshold2: uniquePercentages[1] };
  }
  
  // Для 3+ уникальных положительных процентов
  const count = uniquePercentages.length;
  
  const redCount = Math.max(1, Math.floor(count / 3)); 
  const greenCount = Math.max(1, Math.floor(count / 3)); 
  const yellowCount = Math.max(0, count - redCount - greenCount); 

  let t1, t2;

  t1 = uniquePercentages[redCount - 1]; // Нижняя граница красной зоны (самое маленькое значение в красной группе)

  if (yellowCount > 0) {
    // Если есть желтая группа, t2 - это нижняя граница желтой зоны (самое маленькое значение в желтой группе)
    t2 = uniquePercentages[redCount + yellowCount - 1];
  } else {
    // Желтой группы нет. Есть только красные и зеленые, или все красные.
    if (redCount === count) { // Все элементы красные
      t2 = t1 > 0 ? t1 / 2 : -0.01; // Порог для зеленого значительно ниже, чтобы все было красным
    } else { // Есть красные и зеленые. Зеленые начинаются сразу после красных.
             // t2 должен быть равен t1, чтобы элементы < t1 (и > 0) стали зелеными.
      t2 = t1; 
    }
  }
  
  // Коррекция, если t1 и t2 совпали (случай redCount < count, yellowCount = 0):
  // Это значит, что порог для зеленого должен быть следующим уникальным значением, меньшим t1.
  if (t1 === t2 && yellowCount === 0 && redCount < count) {
    const nextLowerIndex = uniquePercentages.findIndex(p => p < t1);
    if (nextLowerIndex !== -1) {
      t2 = uniquePercentages[nextLowerIndex];
    } else {
      // Если нет меньших значений (все оставшиеся равны t1), они должны быть красными.
      // Делаем порог t2 очень низким, чтобы ничего не стало зеленым без необходимости.
      t2 = t1 > 0 ? t1 / 100 : -0.01; 
    }
  }

  // Финальная проверка: threshold2 не может быть строже (больше), чем threshold1.
  if (t2 > t1) t2 = t1;

  return { threshold1: t1, threshold2: t2 };
};

// Основная функция обработки данных
export const processChartData = (rawChartData, totalViolationsCount, compliantFoundersList, chartType, analysisPeriod, analysisTime) => {
  // rawChartData: e.g. vkAnalysisResult.results.omsu.data
  // compliantFoundersList: e.g. vkAnalysisResult.results.omsu.compliantFounders
  // chartType: 'ОМСУ' or 'ИОМО'
  // analysisPeriod: { startDate, endDate }
  // analysisTime: Date object for when analysis was completed (analysisEndTime)

  const { data = [] } = rawChartData || {};

  if (!data || !Array.isArray(data) || data.length === 0) {
    return {
      hasData: false,
      mainTitle: `Результаты по ${chartType} отсутствуют`,
    };
  }

  // 1. Предварительная обработка и сортировка
  const processedData = data.map(item => ({
    ...item,
    name: item.name || 'Без названия',
    numericPercentage: parseFloat(item.percentage),
    roundedValue: Math.round(parseFloat(item.percentage)),
    // Убедимся что violations и total есть и являются числами
    violations: parseInt(item.violations) || 0,
    total: parseInt(item.total) || 0,
  })).sort((a, b) => b.numericPercentage - a.numericPercentage);

  // 2. Определение необходимости сотых долей
  const roundedCounts = {};
  processedData.forEach(item => {
    roundedCounts[item.roundedValue] = (roundedCounts[item.roundedValue] || 0) + 1;
  });
  const needExtraDecimal = {};
  for (const value in roundedCounts) {
    if (roundedCounts[value] > 1) needExtraDecimal[value] = true;
  }

  // 3. Определение порогов для "светофора" - НОВАЯ ЛОГИКА
  const { threshold1, threshold2 } = determineThresholdsByValue(processedData);

  // 4. Финальное формирование элементов диаграммы
  const chartItems = processedData.map((item, index) => {
    let category, gradient; // Удаляем неиспользуемую переменную color
    
    if (item.numericPercentage === 0) { 
        category = 'none'; gradient = colors.green.gradient;
    } else if (item.numericPercentage >= threshold1) {
      category = 'high'; gradient = colors.red.gradient;
    } else if (item.numericPercentage >= threshold2) {
      category = 'medium'; gradient = colors.yellow.gradient;
    } else { 
      category = 'low'; gradient = colors.green.gradient;
    }

    let formattedPercentage = needExtraDecimal[item.roundedValue]
      ? parseFloat(item.numericPercentage.toFixed(2)).toString()
      : item.roundedValue.toString();
    if (formattedPercentage.endsWith('.00')) formattedPercentage = formattedPercentage.slice(0, -3);
    
    // Используем числовой процент для рендеринга ширины бара
    const percentageForBar = item.numericPercentage;

    return {
      // Передаем только нужные поля для ComplianceChartFixed
      name: item.name,
      total: item.total,
      violations: item.violations,
      percentage: percentageForBar, // Числовой процент для ширины бара
      displayPercentage: formattedPercentage, // Строковый формат для отображения рядом со статами (если нужно)
      gradient, 
      category, 
    };
  });

  // 5. Подготовка текста для блока "Выполнили норму" - НЕ НУЖНА, передаем список
  // let compliantFoundersTextLines = []; ...

  // 6. Формирование заголовков и меток
  const mainTitle = analysisPeriod?.analysisMode === 'monthly_4weeks'
    ? `Количество пабликов ${chartType}, нарушивших норму хотя бы в одном периоде месяца`
    : `Количество пабликов ${chartType}, не выполнивших норму публикаций`;
  
  // const formattedStartDate = formatDatePart(analysisPeriod.startDate);
  // const formattedEndDate = formatDatePart(analysisPeriod.endDate);
  // const periodLabel = `Период: с ${formattedStartDate} по ${formattedEndDate}`; // Не используется

  let dateDisplayInfo = 'Данные актуальны на неопределенное время'; // Fallback
  const { startDate, endDate, analysisMode, analysisMetadata } = analysisPeriod || {};

  if (analysisTime instanceof Date && !isNaN(analysisTime.getTime())) {
    const analysisDatePart = new Date(analysisTime.getFullYear(), analysisTime.getMonth(), analysisTime.getDate());
    let endDateDatePart = null;
    if (endDate) {
        const [year, month, day] = endDate.split('-').map(Number);
        if (!isNaN(year) && !isNaN(month) && !isNaN(day)) {
             endDateDatePart = new Date(year, month - 1, day);
        }
    }

    const formatToDDMMYY = (dateStr) => {
        if (!dateStr) return '??.??.??';
        const [year, month, day] = dateStr.split('-').map(Number);
        if (isNaN(year) || isNaN(month) || isNaN(day)) return '??.??.??';
        return `${String(day).padStart(2, '0')}.${String(month).padStart(2, '0')}.${String(year).slice(-2)}`;
    };

    if (endDateDatePart && analysisDatePart.getTime() === endDateDatePart.getTime()) {
      // Дата окончания анализа совпадает с endDate из периода
      const moscowTime = new Date(analysisTime.getTime() + MSK_OFFSET_MILLISECONDS);
      const hours = moscowTime.getUTCHours().toString().padStart(2, '0');
      const minutes = moscowTime.getUTCMinutes().toString().padStart(2, '0');
      const day = moscowTime.getUTCDate().toString().padStart(2, '0');
      const month = (moscowTime.getUTCMonth() + 1).toString().padStart(2, '0');
      const year = moscowTime.getUTCFullYear().toString().slice(-2);
      dateDisplayInfo = `по состоянию на ${hours}:${minutes} ${day}.${month}.${year}`;
    } else if (startDate && endDate) {
      // Даты не совпадают, показываем период
      dateDisplayInfo = `за период с ${formatToDDMMYY(startDate)} по ${formatToDDMMYY(endDate)}`;
    } else if (analysisTime) {
        // Fallback если startDate/endDate не предоставлены, но есть время анализа
        const moscowTime = new Date(analysisTime.getTime() + MSK_OFFSET_MILLISECONDS);
        const hours = moscowTime.getUTCHours().toString().padStart(2, '0');
        const minutes = moscowTime.getUTCMinutes().toString().padStart(2, '0');
        const day = moscowTime.getUTCDate().toString().padStart(2, '0');
        const month = (moscowTime.getUTCMonth() + 1).toString().padStart(2, '0');
        const year = moscowTime.getUTCFullYear().toString().slice(-2);
        dateDisplayInfo = `анализ на ${hours}:${minutes} ${day}.${month}.${year}`;
    }
  } else if (typeof analysisTime === 'string') { // Если analysisTime это строка (например, ISO UTC)
    try {
      const dateUtc = new Date(analysisTime);
      if (isNaN(dateUtc.getTime())) throw new Error('Invalid date string for analysisTime');
      
      // Повторяем логику сравнения и форматирования как выше
      const analysisDatePart = new Date(dateUtc.getFullYear(), dateUtc.getMonth(), dateUtc.getDate());
      let endDateDatePart = null;
      if (endDate) {
          const [year, month, day] = endDate.split('-').map(Number);
          if (!isNaN(year) && !isNaN(month) && !isNaN(day)) {
               endDateDatePart = new Date(year, month - 1, day);
          }
      }

      const formatToDDMMYY = (dateStr) => {
        if (!dateStr) return '??.??.??';
        const [year, month, day] = dateStr.split('-').map(Number);
        if (isNaN(year) || isNaN(month) || isNaN(day)) return '??.??.??';
        return `${String(day).padStart(2, '0')}.${String(month).padStart(2, '0')}.${String(year).slice(-2)}`;
      };

      if (endDateDatePart && analysisDatePart.getTime() === endDateDatePart.getTime()) {
        const moscowTime = new Date(dateUtc.getTime() + MSK_OFFSET_MILLISECONDS);
        const hours = moscowTime.getUTCHours().toString().padStart(2, '0');
        const minutes = moscowTime.getUTCMinutes().toString().padStart(2, '0');
        const day = moscowTime.getUTCDate().toString().padStart(2, '0');
        const month = (moscowTime.getUTCMonth() + 1).toString().padStart(2, '0');
        const year = moscowTime.getUTCFullYear().toString().slice(-2);
        dateDisplayInfo = `по состоянию на ${hours}:${minutes} ${day}.${month}.${year}`;
      } else if (startDate && endDate) {
        dateDisplayInfo = `за период с ${formatToDDMMYY(startDate)} по ${formatToDDMMYY(endDate)}`;
      } else {
        const moscowTime = new Date(dateUtc.getTime() + MSK_OFFSET_MILLISECONDS);
        const hours = moscowTime.getUTCHours().toString().padStart(2, '0');
        const minutes = moscowTime.getUTCMinutes().toString().padStart(2, '0');
        const day = moscowTime.getUTCDate().toString().padStart(2, '0');
        const month = (moscowTime.getUTCMonth() + 1).toString().padStart(2, '0');
        const year = moscowTime.getUTCFullYear().toString().slice(-2);
        dateDisplayInfo = `анализ на ${hours}:${minutes} ${day}.${month}.${year}`;
      }
    } catch (e) {
      console.error("Error processing analysisTime string or period dates:", analysisTime, analysisPeriod, e);
      // dateDisplayInfo останется с fallback значением
      if (startDate && endDate) { // Если есть хотя бы период, покажем его
        const formatToDDMMYY = (dateStr) => {
            if (!dateStr) return '??.??.??';
            const [year, month, day] = dateStr.split('-').map(Number);
            if (isNaN(year) || isNaN(month) || isNaN(day)) return '??.??.??';
            return `${String(day).padStart(2, '0')}.${String(month).padStart(2, '0')}.${String(year).slice(-2)}`;
        };
        dateDisplayInfo = `за период с ${formatToDDMMYY(startDate)} по ${formatToDDMMYY(endDate)}`;
      }
    }
  }

  if (analysisMode === 'monthly_4weeks' && analysisMetadata?.monthLabel) {
    const periodsText = Array.isArray(analysisMetadata.periods)
      ? analysisMetadata.periods.map(period => period.label).join(', ')
      : '1-7, 8-14, 15-21, 22-28';
    dateDisplayInfo = `месячная сводка ${analysisMetadata.monthLabel}: ${periodsText}`;
  }
  
  // Легенда формируется статично в компоненте, здесь можно не возвращать
  // const legendItems = [ ... ];

  return {
    hasData: true,
    mainTitle,
    dateDisplayInfo, // Используем новое имя
    items: chartItems, 
    totalViolations: totalViolationsCount,
    compliantFoundersList: compliantFoundersList || [], // Передаем исходный список
    // Добавляем startDate и endDate для возможного использования в компоненте графика, если потребуется
    startDate: analysisPeriod ? analysisPeriod.startDate : undefined,
    endDate: analysisPeriod ? analysisPeriod.endDate : undefined,
  };
}; 
